<template>
  <div class="footer-all">
    <div class="ndata-footer" :style="{marginTop:marginTopHeight+'px'}">
      <el-divider class="footer-divider"/>
      <el-row>
        <el-col :span="12" :xs="24">
          <div class="footer-content">
            <div v-if="siteIntro" >
              <span  class="footer-font">主办单位：{{siteIntro}}</span>
            </div>
            <div v-if="websit && websit.guidance">
              <span  class="footer-font">指导单位：{{websit.guidance}}</span>
            </div>
            <div v-if="websit && websit.undertake">
              <span  class="footer-font">承办单位：{{websit.undertake}}</span>
            </div>
            <div v-if="websit && websit.siteAddress">
               <span  class="footer-font">地址：{{websit.siteAddress}}</span>
            </div>
            <div  v-if="websit && websit.zipCode">
              <span   class="footer-font">邮编：{{websit.zipCode}}</span>
            </div>
            <div  v-if="websit && websit.contactTelephone">
              <span   class="footer-font">电话：{{websit.contactTelephone}}</span>
            </div>
            <div  v-if="websit && websit.contactMail">
              <span   class="footer-font">邮箱：{{websit.contactMail}}</span>
            </div>
            <div>
<!--              <span  class="footer-font">技术支持：美亚联创（北京）科技有限公司</span>-->
              <span  class="footer-font">技术支持：恩数互联（北京）智能科技有限公司</span>
            </div>
            <!-- 宁夏相关 -->
<!--            <div>-->
<!--              <span class="footer-font">相关链接：-->
<!--                <a style="color: white" target="_blank" href="https://shgz.mca.gov.cn/SWMS/LEAP/swmss/index.html#/web">中国社会工作网</a>&nbsp;&nbsp;-->
<!--                <a style="color: white" target="_blank" href="http://www.swchina.org/">社工中国</a>&nbsp;&nbsp;-->
<!--                <a style="color: white" target="_blank" href="https://haogongyi.org.cn/">好公益平台</a>&nbsp;&nbsp;-->
<!--                <a style="color: white" target="_blank" href="http://mca.nx.gov.cn/">宁夏回族自治区民政厅</a></span>-->
<!--            </div>-->
            <span class="footer-font">京ICP备19032597号-7</span>
          </div>
        </el-col>
        <el-col :span="12" :xs="24">
          <div>
            <el-row>
<!--              <el-col :span="isMobile?12:6">-->
<!--                <div style="text-align: center">-->
<!--                  <div class="qrCodeUrl">-->
<!--                    <div id="qrCodeUrl"></div>-->
<!--                  </div>-->
<!--                  <div style="line-height:27px;color: #ffffff;margin-right: 39px">移动学员端</div>-->
<!--                </div>-->
<!--              </el-col>-->
              <!--残联去掉-->
              <el-col :span="isMobile?12:6" v-if="websit && websit.qrcodePath1">
                <div style="text-align: center;">
                  <img :src="websit.qrcodePath1"  class="footer_img">
                  <div class="footer_fon">{{websit.qrcodeTitle1}}</div>
<!--                  <img src="../assets/ningxia/ningxia.jpg" class="footer_img">-->
<!--                  <div class="footer_fon">宁夏社工站一线社工培训学员群</div>-->
                </div>
              </el-col>
              <el-col :span="isMobile?12:6" v-if="websit && websit.qrcodePath2">
                <div style="text-align: center;">
                  <img :src="websit.qrcodePath2"  class="footer_img">
                  <div class="footer_fon">{{websit.qrcodeTitle2}}</div>
                  <!--                  <img src="../assets/ningxia/ningxia.jpg" class="footer_img">-->
                  <!--                  <div class="footer_fon">宁夏社工站一线社工培训学员群</div>-->
                </div>
              </el-col>
              <el-col :span="isMobile?12:6" v-if="websit && websit.qrcodePath3">
                <div style="text-align: center;">
                  <img :src="websit.qrcodePath3"  class="footer_img">
                  <div class="footer_fon">{{websit.qrcodeTitle3}}</div>
                  <!--                  <img src="../assets/ningxia/ningxia.jpg" class="footer_img">-->
                  <!--                  <div class="footer_fon">宁夏社工站一线社工培训学员群</div>-->
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import QRCode from 'qrcodejs2'
import constant from '../constant'
export default {
  props: {
    topHeight: {
      type: Number,
      default: 10
    }
  },
  data () {
    return {
      marginTopHeight: 10,
      year: new Date().getFullYear(),
      dictInfo: {},
      isMobile: null,
      // qrUrl: constant.STUDENT_PATH + '/student/index.action'
      qrUrl: constant.URL_DOWN + '/studycenter'
    }
  },
  computed: {
    ...mapGetters(['footerList', 'siteIntro', 'websit'])
  },
  watch: {
    topHeight: {
      handler (val) {
        this.marginTopHeight = val
      },
      immediate: true
    }
  },
  created () {
    this.ismobile()
    // setTimeout(() => {
    //   this.qrCodeGeneration()
    // }, 300)
  },
  mounted () {
    this.$nextTick(function () {
      // this.qrCodeGeneration()
    })
  },
  methods: {
    ismobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      this.isMobile = flag
    },
    // 二维码生成
    qrCodeGeneration () {
      // if (this.websit) {
      //   this.qrUrl = this.websit.siteDomain + '/studycenter'
      // }
      // 生成二维码
      this.$nextTick(function () {
        document.getElementById('qrCodeUrl').innerHTML = ''
        let qrCodeUrl = new QRCode('qrCodeUrl', {
          width: 140,
          height: 140,
          text: this.qrUrl,
          colorDark: '#000000',
          colorLight: '#fff'
        })
        console.log(qrCodeUrl)
      })
    }
  }
}
</script>
<style lang="less" scoped >
  .footer-all{
    height: 120PX;
  }
  .ndata-footer{
    position: relative;
    line-height: 35px;
    background-color: #d10b1a;
    padding-bottom: 10px;
    /*height: 200px;*/
  }
  .footer-font{
    font-size: 16px;
    font-family: SourceHanSansCN-Regular-GBpc-EUC-H-, SourceHanSansCN-Regular-GBpc-EUC-H;
    font-weight: normal;
    color: #FFFFFF;
  }
  .footer-left{
    display: grid;
    float: left;
    padding-top: 20px;
    padding-left: 20px;
    .footer-img{
      width: 50px;
      height: 50px;
      margin-left: 50px;
      transition: all 0.4s;
      -moz-transition:all .4s;
      -webkit-transition:all .4s;
      -o-transition:all .4s;
      background: url("../assets/155@1x.png");
      background-repeat:no-repeat;   /* 不会重复 */
      background-position: center;   /* 是为了让图片放大的时候从中部放大，不会偏移 */
      background-size: 100% 100%;
      cursor: pointer;
      /*&:hover{*/
      /*  width: 200px;*/
      /*  height: 200px;*/
      /*  background-size: 150% 150%;*/
      /*}*/
    }
    span{
      cursor: pointer;
      color: #ffffff;
    }
  }
  .footer-divider{
    position: relative;
    bottom: 7px;
    border: solid 1px #d10b1a;
    background: #d10b1a;
    /*width: 99.9%;*/
  }
  /deep/.el-divider--horizontal{
    height: 2px!important;
    margin: 10px 0px!important;
  }
  .footer-content{
    margin-left: 290px;
  }
  @media (max-width: 950px) {
    .footer-content{
      margin-left: 40px;
    }
  }
  @media ( max-width : 950px){
    .footer-code{
      margin-left: 30px;
    }
  }
  .qrCodeUrl{
    width: 150px;
    height: 150px;
    background: #ffffff;
    margin-left: 20px;
  }
  #qrCodeUrl{
    padding: 5px;
  }
  .footer_img{
    width: 150px;
  }
  .footer_fon{
    line-height:25px;
    color: #ffffff
  }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue